function copyHTML () {

  $(document).on('click', '.clipboard-block__toggler', e => {
    e.preventDefault()
    const target = e.currentTarget
    const container = target.closest('.clipboard-block')
    const content = container.querySelector('.clipboard-block__content')
    
    const clipboardItem = new ClipboardItem({
      "text/plain": new Blob(
        [content.innerHTML],
        { type: "text/plain" }
      ),
      "text/html": new Blob(
        [content.innerHTML],
        { type: "text/html" }
      ),
    });
      
    navigator.clipboard.write([clipboardItem]);

  })

}

export { copyHTML }